import { Suspense, lazy } from 'react';
import { useStore } from '../store.js';
import { ActivityBar } from './ActivityBar.js';
import { StatusBar } from './StatusBar.js';
import { EditorView } from './EditorView.js';
import { DashboardView } from './DashboardView.js';
import { LintView } from './LintView.js';
import { BuildView } from './BuildView.js';
import { IntegrationsPanel } from './IntegrationsPanel.js';
import { ReadinessLadder } from './ReadinessLadder.js';
import { SkeletonCard } from '../components/Skeleton.js';
import { useDesignBlock } from '../hooks/useDesignBlock.js';

const ConstellationView = lazy(() =>
  import('../views/ConstellationView.js').then((m) => ({ default: m.ConstellationView })),
);

export function Workbench() {
  useDesignBlock();
  const view = useStore((s) => s.view);

  return (
    <div className="flex h-screen flex-col">
      <div className="flex flex-1 min-h-0">
        <ActivityBar />
        <main className="min-w-0 flex-1 flex flex-col">
          <ReadinessLadder />
          <IntegrationsPanel />
          <div className="flex-1 min-h-0">
            {view === 'dashboard' && <DashboardView />}
            {view === 'editor' && <EditorView />}
            {view === 'constellation' && (
              <Suspense fallback={<div className="p-4"><SkeletonCard /></div>}>
                <ConstellationView />
              </Suspense>
            )}
            {view === 'lint' && <LintView />}
            {view === 'build' && <BuildView />}
          </div>
        </main>
      </div>
      <StatusBar />
    </div>
  );
}
